import axios, {AxiosPromise, CancelToken} from 'axios';
import {CancelablePromise} from '@zvne/fe-framework/dist/data-access/generic-types';

export type AxiosPromiseConstructor<T> = (cancelToken: CancelToken) => AxiosPromise<T>;

export function axiosToCancelablePromise<T>(promiseConstructor: AxiosPromiseConstructor<T>): CancelablePromise<T> {
    const cancelToken = axios.CancelToken.source();
    const promise = new Promise<T>((resolve, reject) => {
        promiseConstructor(cancelToken.token)
            .then(response => resolve(response.data))
            .catch(error => {
                if (axios.isCancel(error)) {
                    return;
                }
                reject(error);
            });
    });
    return {
        promise: promise,
        cancel: cancelToken.cancel
    };
}
